import { Spinner } from "flowbite-react";

import {
  FEATURE_FLAGS,
  useFeatureFlags,
  useHubspot,
} from "../../../../contexts";
import { HsStatusBar } from "./HsStatusBar";
import { HsSetupStepper } from "./HsSetupStepper";
import { HsSummary } from "./HsSummary";
import { HsSignalWriteback } from "./HsSignalWriteback";

// The page has four states, rendered explicitly:
//   1. Not connected            -> status bar only (connect CTA lives there)
//   2. Connected, fields not    -> status bar explains the Resync action
//      synced yet
//   3. Connected, configuring   -> setup stepper (pipelines -> mapping -> enable)
//   4. Sync enabled (ACTIVE)    -> read-only summary of the configuration
export const HubspotIntegration = () => {
  const {
    hasIntegration,
    isHubspotFieldsSynced,
    pipelines,
    loading,
    disableForm,
    hsIntegration,
  } = useHubspot();
  const { isEnabled } = useFeatureFlags();
  // Writing back needs a working connection; the card also hides itself when the backend
  // says the team can't use it.
  const showWriteback =
    isEnabled(FEATURE_FLAGS.HUBSPOT_SIGNAL_WRITEBACK) &&
    hsIntegration?.status === "ACTIVE";

  const renderBody = () => {
    // Gated on the RECORD, not on health: state 3 below is the setup wizard, which
    // runs *during* PENDING_SETUP. Gating this on connection health would leave every
    // team mid-onboarding staring at a Connect button, permanently.
    if (!hasIntegration) return null;
    if (loading) {
      return (
        <div className="flex justify-center py-10">
          <Spinner size="lg" />
        </div>
      );
    }
    if (!isHubspotFieldsSynced || pipelines.length === 0) return null;
    if (disableForm) return <HsSummary />;
    return <HsSetupStepper />;
  };

  return (
    <div className="flex min-h-full flex-1 flex-col gap-4">
      <div className="animation-slide-up-lil-bounce mt-1 flex w-full flex-col gap-4 rounded-lg bg-white py-4 shadow">
        <HsStatusBar />
      </div>

      {showWriteback && <HsSignalWriteback />}

      {renderBody()}
    </div>
  );
};
